import { RoleIdDto } from '../services/iamapi/iamapi.services';

export class UnassignRolesByUserIdRequest {
  userId: string;
  requestBody: RoleIdDto[];
}
